require('./transactionShowContainer.scss')

module.exports = {
  template: require('./transactionShowContainer.pug')()
  controller: require('./transactionShowContainer.ctrl')
}
